
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DataTableHeader } from 'vuetify';
import { TicketEscalationInterface } from '@/services/QC-V2/escalation/interfaces';
import { ProfileMapInterface } from '@/services/QC-V2/chat/interfaces';

interface DataTableOptions {
  page: number,
  itemsPerPage: number,
  sortBy: string[],
  sortDesc: boolean[],
  groupBy: string[],
  groupDesc: boolean[],
  multiSort: boolean,
  mustSort: boolean
}

@Component({
  mixins: [
    Themeable,
  ],
})
export default class EscalationTicketsTable extends Vue {
  @Prop() private escalations!: TicketEscalationInterface[];
  @Prop({ default: 0 }) private totalItems!: number;
  @Prop({ default: () => [] }) private disabledTicketIds!: number[];
  @Prop({ default: 1 }) private page!: number;
  @Prop() private profilesMap!: ProfileMapInterface;

  private loading: boolean = false;
  private options: DataTableOptions = {
    itemsPerPage: 10,
    page: this.page,
  } as DataTableOptions;

  private selectedEscalationId: number = 0;
  private headers: DataTableHeader[] = [
    { text: 'Requester', value: 'requester', sortable: false },
    { text: 'Subject', value: 'ticket.subject', sortable: false },
    { text: 'From', value: 'from', sortable: false },
    { text: 'To', value: 'to', sortable: false },
  ];

  @Watch('page')
  private handlePageUpdate(): void {
    this.options.page = this.page;
  }

  @Watch('escalations')
  private handleEscalationsUpdate(): void {
    this.$forceUpdate();
  }

  @Watch('options', { deep: true })
  private handlePageChange(): void {
    this.$emit('change-page', this.options.page);
  }

  private getEscalation(id: number): void {
    this.selectedEscalationId = id;
    this.$emit('get-ticket-escalation', id);
  }

  private getAvatar(name: string): string {
    const nameArr = name.split(' ');
    return `https://ui-avatars.com/api/?name=${nameArr.join('+')}&background=random&&length=${nameArr.length}`;
  }
}
